// Carry Roll Club recommendation — recommend club for target distance (10.4). Pure function.
/** Recommend the club whose carry is nearest to (and ideally just under) the target. */
export function recommendClub(targetM, bag, _env) {
    if (bag.length === 0) {
        return { club: null, message: 'Add clubs to your bag to get a recommendation.' };
    }
    // Prefer the club that carries closest to target without overshooting too much.
    const sorted = [...bag].sort((a, b) => Math.abs(a.carryM - targetM) - Math.abs(b.carryM - targetM));
    const best = sorted[0];
    return {
        club: best,
        message: `${best.clubName} carries ${Math.round(best.carryM)} m, nearest to your ${Math.round(targetM)} m target.`,
    };
}
//# sourceMappingURL=recommend.js.map